export default function subscriber(state) {
  const handlers = [];

  state.publish = publish.bind(this, handlers);

  return {
    subscribe(handler) {
      if (typeof(handler) !== 'function') {
        // eslint-disable-next-line no-throw-literal
        throw 'Subscription handler must be function';
      }

      handlers.push(handler);

      return function unsubscribe() {
        const index = handlers.indexOf(handler);
        ~index && handlers.splice(index, 1);
      };
    },
  };
}

function publish(handlers, payload) {
  handlers
    .slice(0)
    .forEach(handler => handler(payload));
}
